// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */

export { SortOrder as TableSortOrder } from './table/constants';
export { TableSortStep } from './table/sort-column';
export { AddColumnStep } from './table/add-column';
export type { TableColumnOrdering } from './table/types';
